import { Copy, Download } from "lucide-react";
import { imgUrl } from "../lib/api";
import { toast } from "sonner";

// UPI payment block: QR code, UPI ID, copy + download actions. Used wherever a customer pays via UPI.
export function UpiPayBlock({ settings, compact = false }) {
  const upiId = settings?.upi_id || "";
  const qr = settings?.upi_qr_url;

  const copyUpi = async () => {
    try {
      await navigator.clipboard.writeText(upiId);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = upiId;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    toast.success("UPI ID Copied Successfully");
  };

  const downloadQr = async () => {
    try {
      const res = await fetch(imgUrl(qr));
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "anaya-upi-qr.jpg";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("QR Code downloaded");
    } catch {
      toast.error("Download failed — long-press the QR image to save it");
    }
  };

  return (
    <div className="mt-3" data-testid="upi-pay-block">
      {qr && (
        <div className="flex flex-col items-center">
          <img src={imgUrl(qr)} alt="Anaya Fashion & Gifts UPI QR code" data-testid="upi-qr-image"
            className={`${compact ? "w-40" : "w-48"} rounded-2xl bg-white p-2 shadow-sm ring-1 ring-primary/20`} />
        </div>
      )}
      <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
        <p className="text-sm">Pay to UPI ID: <span className="font-medium tracking-wide" data-testid="upi-id-text">{upiId}</span></p>
        <button type="button" data-testid="upi-copy-btn" onClick={copyUpi}
          className="flex items-center gap-1.5 rounded-full bg-foreground px-3.5 py-1.5 text-[10px] tracking-[0.15em] text-white uppercase transition-colors hover:bg-primary">
          <Copy size={12} /> Copy UPI ID
        </button>
      </div>
      {qr && (
        <div className="mt-2 flex justify-center">
          <button type="button" data-testid="upi-qr-download-btn" onClick={downloadQr}
            className="flex items-center gap-2 rounded-full border border-input bg-white/80 px-4 py-2 text-[11px] tracking-[0.15em] uppercase transition-colors hover:bg-secondary">
            <Download size={13} /> Download QR Code
          </button>
        </div>
      )}
    </div>
  );
}
